import { axios } from '../plugins/axios';

export default {
  namespaced: true,
  state: {
    tipoExpediente: [],
  },
  getters: {
    getTipoExpediente: (state) => state.tipoExpediente,
  },
  mutations: {
    SET_TIPO_EXPEDIENTE(state, tipoExpediente) {
      state.tipoExpediente = tipoExpediente;
    },
  },
  actions: {
    async fetchTipoExpediente({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catexpediente')
        .then((response) => {
          commit('SET_TIPO_EXPEDIENTE', response.data.data);
        });
    },
  },
};
